import { render, staticRenderFns } from "./add-tp.vue?vue&type=template&id=34356934&scoped=true"
import script from "./add-tp.vue?vue&type=script&lang=js"
export * from "./add-tp.vue?vue&type=script&lang=js"
import style0 from "./add-tp.vue?vue&type=style&index=0&id=34356934&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34356934",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\XM\\QD\\yangzhou\\merchant-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34356934')) {
      api.createRecord('34356934', component.options)
    } else {
      api.reload('34356934', component.options)
    }
    module.hot.accept("./add-tp.vue?vue&type=template&id=34356934&scoped=true", function () {
      api.rerender('34356934', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/scenic-spot/creatProduct/add-tp.vue"
export default component.exports